import styled from 'styled-components'
// import FacebookLogin from 'react-facebook-login'
import GoogleLogin from 'react-google-login'
import { FacebookLogin } from 'react-facebook-login-component';

import GenericLogo from '../../../GenericComponents/GenericLogo'

import EmailIcon from '../../../assets/REDESIGN_Assets/LoginScreen/email-icon.svg'
import GoogleIcon from '../../../assets/REDESIGN_Assets/LoginScreen/google-icon.svg'
import FacebookIcon from '../../../assets/REDESIGN_Assets/LoginScreen/facebook-icon.svg'
import DesktopWomanImage from '../../../assets/REDESIGN_Assets/LoginScreen/login_woman_image.webp'
import MobileWomanImage from '../../../assets/REDESIGN_Assets/LoginScreen/woman-login-image.png'

export const LoginScreenBox = styled.div `
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media only screen and (max-width: 600px) {
    justify-content: flex-end;
    height: 100vh;
    width: 100%;
  }

  span:nth-child(5),
  span:nth-child(3),
  span:nth-child(4),
  span:nth-child(6),
  span:nth-child(8),
  span:nth-child(7) {
    width: 100%;

    button {
      width: 100%;
      display: flex;
      align-items: center;
      position: relative;
      justify-content: center;
      flex-direction: row;
      padding: 20px 40px;
      font-family: 'Nunito';
      font-size: 1.1rem;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.53;
      letter-spacing: -0.38px;
      text-align: center;
      color: #342152;
      border-radius: 19px;
      border: 1px solid transparent;
      box-sizing: border-box;
      font-family: 'Nunito';
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: -0.32px;
      text-align: left;
      color: #1b0f25;
      margin: 5px 0;
      transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
      cursor: pointer;
      background-color: #5868bb;
      color: white;
      padding-left: 27%;

      @media only screen and (max-width: 600px) {
        padding: 10px;
        font-size: 1rem;
      }

      /* @media only screen and (max-width: 1600px) {
        font-size: 0.9rem;
      }
      @media only screen and (max-width: 1500px) {
        font-size: 0.8rem;
      }
      @media only screen and (max-width: 1400px) {
        font-size: 0.7rem;
        padding: 10px;
      } */

      &:after {
        position: absolute;
        content: '';
        width: 18px;
        height: 100%;
        left: 15%;
        top: 0;
        background-image: url(${FacebookIcon});
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }

      &:hover {
        transform: scale(1.05);
        box-shadow: 0 1.5px 1.9px -12px rgba(0, 0, 0, 0.022),
          0 3.7px 4.5px -12px rgba(0, 0, 0, 0.032),
          0 7px 8.5px -12px rgba(0, 0, 0, 0.04),
          0 12.5px 15.2px -12px rgba(0, 0, 0, 0.048),
          0 23.4px 28.4px -12px rgba(0, 0, 0, 0.058),
          0 56px 68px -12px rgba(0, 0, 0, 0.08);
      }
    }
  }

  .register-link {
    color: #a1ff68;
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
  }
`
export const LoginWomanImage = styled.div `
  position: absolute;
    top: 14vh;
    left: 10%;
    height: 75vh;
    width: 60vw;
  background: url(${MobileWomanImage});
  overflow: hidden;
    background-repeat: no-repeat;
    background-size: 50%;


  @media only screen and (max-width: 600px) {

    top: 0;
    left: 0%;
    height: 75vh;
    width: 100vw;
    background-size: 100%;
    left: 0;

  }



  @media (min-width: 1024px) and (max-width: 1280px) {
    top: -5vh;
    left: 27%;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    height: 100vh;
    top: 0vh;
    left: 30%;
  }

  &.tablet-view{
    @media (orientation: portrait){
      background-size: 100%;
      left: 18%;
    }
    @media (orientation: landscape){
      left:34%;
    }
  }
`

export const LoginLogo = styled(GenericLogo)
`
  position: absolute;
  bottom: 7.5vh;
  width: 28vw;
  height: 21vh;
  left: 17vw;

  @media only screen and (max-width: 600px) {
    width: 70vw;
    left: 15vw;
    top: 24vh;
  }

  /* @media only screen and (max-width: 400px) {
    width: 80vw;
    left: 0;
    top: 28vh;
  } */

  @media (min-width: 1024px) and (max-width: 1280px) {
    display: none;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    bottom: 1.5vh;
    width: 35vw;
    left: 32.5vw;
  }
`

export const ButtonLoginIcon = styled.div `
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-right: 10%;
  margin-left: 12%;

  &.facebook {
    background-image: url(${FacebookIcon});
  }
  &.google {
    /* background-image: url(${GoogleIcon}); */
  }
  &.email {
    background-image: url(${EmailIcon});

    margin-right: 10%;
    margin-left: 5%;
    @media only screen and (max-width: 600px) {
      margin-right: 10%;
      margin-left: 12%;
    }
  }
`

export const CustomFaceBookLoginButton = styled(FacebookLogin)
`
  display: flex;
  width: 100px;
  justify-content: center;
  font-size: 0.9rem;

  .facebook-button-wrapper {
    justify-content: center;
  }
`

export const GoogleButton = styled.button `
  width: 100%;
  display: flex;
`

export const CustomGoogleLoginButton = styled(GoogleLogin)
`
  width: 100%;
  display: flex !important;
  align-items: center !important;
  position: relative;
  justify-content: center;

  flex-direction: row;
  padding: 10px !important;
  font-family: 'Nunito';
  font-size: 1.1rem !important;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.53;
  letter-spacing: -0.38px;
  text-align: center;
  color: #342152;
  border-radius: 19px !important;
  border: 1px solid transparent;
  box-sizing: border-box;
  font-family: 'Nunito' !important;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.32px;
  text-align: left;
  color: #1b0f25;
  margin: 5px 0;
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;
  background-color: #342152 !important;
  color: white !important;
  padding-left: 27% !important;

  @media only screen and (max-width: 1600px) {
    font-size: 0.9rem !important;
  }
  @media only screen and (max-width: 1500px) {
    font-size: 0.8rem !important;
  }
  @media only screen and (max-width: 1400px) {
    font-size: 0.7rem !important;
    padding: 10px !important;
  }

  @media only screen and (max-width: 1100px) {
    justify-content: flex-end;
  }

  @media only screen and (max-width: 600px) {
    padding: 0px !important;
    justify-content: center;
    font-size: 1rem !important;
  }

  div {
    display: none;
  }

  &:after {
    position: absolute;
    content: '';
    width: 18px;
    height: 100%;
    left: 15%;
    top: 0;
    background-image: url(${GoogleIcon});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;

    @media only screen and (max-width: 600px) {
      left: 15%;
    }
  }

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 1.5px 1.9px -12px rgba(0, 0, 0, 0.022),
      0 3.7px 4.5px -12px rgba(0, 0, 0, 0.032),
      0 7px 8.5px -12px rgba(0, 0, 0, 0.04),
      0 12.5px 15.2px -12px rgba(0, 0, 0, 0.048),
      0 23.4px 28.4px -12px rgba(0, 0, 0, 0.058),
      0 56px 68px -12px rgba(0, 0, 0, 0.08);
  }
`

export const DefaultCardContainer = styled.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0;
  width: 100%;
  transition: all 0.5s cubic-bezier(0.215, 0.61, 0.355, 1);
  z-index: 5;
`

export const FacebookLoginButton = styled(FacebookLogin)
`
  width: 100%;
  border: none;
  background: transparent;
  padding:0;
`
export const GoToCHallengeButton = styled.button`

      display: flex;
      align-items: center;
      position: absolute;
      top:3%;right:3%;
      justify-content: center;
      flex-direction: row;
      padding: 20px 40px;
      font-family: 'Nunito';
      font-size: 1.1rem;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.53;
      letter-spacing: -0.38px;
      text-align: center;
      color: #342152;
      border-radius: 19px;
      border: 1px solid transparent;
      box-sizing: border-box;


      transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
      cursor: pointer;
      background-color: #a1ff68;
      /* color: white; */



`
